export default function capitalize(string) {
	const first = string.substr(0, 1).toUpperCase()
	const rest = string.substring(1).toLowerCase()

	return `${first}${rest}`
}



// WEBPACK FOOTER //
// ./src/lib/capitalize.js